import React from "react";

export default function ThanksgivingFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-6th2{fill:#f7af3c}.cls-6th3{fill:#3b591b}.cls-6th5{fill:#f4691c}.cls-6th6{fill:#e2951a}.cls-6th8{fill:#d8860e}.cls-6th9{fill:#f97821}.cls-6th10{fill:#efa829}.cls-6th11{fill:#ef5703}.cls-6th12{fill:#678428}.cls-6th13{fill:#d64c00}.cls-6th15{fill:#2f4714}.cls-6th16{fill:#425910}.cls-6th17{fill:#aa3d00}.cls-6th18{fill:#fc8449}.cls-6th21{fill:#f76405}.cls-6th22{fill:#d81400}.cls-6th24{fill:#56752f}"
            }
          </style>
        </defs>
        <path
          d="M1099.75 1547.19c7.81-4.8-14.63-88.24-38.63-87.41-1.02.04-5.51.34-8.04 3.93-12.25 17.42 38.65 88.4 46.67 83.48Z"
          className="cls-6th10"
        />
        <path
          d="M1098.97 1549.6c-14.08-6.83 41.08-166.1 86.43-170.73 1.93-.2 10.4-.78 14.64 5.17 20.58 28.91-86.62 172.56-101.06 165.55Z"
          className="cls-6th6"
        />
        <path
          d="M1080.02 1627.22c-8.64-8.37 61.64-111.4 94.69-103.86 1.41.32 7.52 1.93 9.36 7.3 8.93 26.06-95.19 105.15-104.05 96.56Z"
          className="cls-6th10"
        />
        <path
          d="M1086.98 1590.45c3.88-5.42-20.72-52.31-34.56-44.6-.59.33-3.16 1.87-4.13 4.93-4.71 14.85 34.71 45.23 38.69 39.67Z"
          className="cls-6th6"
        />
        <path
          d="M1118.2 1493.88c-20.55 55.35-35.78 112.5-45.39 170.75.66-7.36 1.61-14.69 2.59-22.01 7.4-51.2 21.64-101.51 42.8-148.74Z"
          className="cls-6th6"
        />
        <path
          d="M439.22 1511.86c-4.92-.74-11.26-47.08.93-51.75.52-.2 2.83-1 4.85.26 9.81 6.09-.74 52.25-5.79 51.49Z"
          className="cls-6th15"
        />
        <path
          d="M440.12 1512.89c5.61-6.38-55.56-74.12-79.24-66.83-1.01.31-5.37 1.81-6.24 5.68-4.22 18.77 79.72 67.7 85.48 61.15Z"
          className="cls-6th3"
        />
        <path
          d="M465.96 1547.58c2.57-6-54.33-42.49-69.3-31.74-.64.46-3.36 2.55-3.15 5.62 1.02 14.88 69.82 32.28 72.45 26.12Z"
          className="cls-6th15"
        />
        <path
          d="M454.73 1530.72c-3.08-1.88-.64-30.46 7.92-29.55.36.04 1.98.26 3.11 1.58 5.49 6.41-7.86 29.89-11.02 27.96Z"
          className="cls-6th3"
        />
        <path
          d="M417.77 1488.56c23.74 21.47 43.78 47.19 58.69 75.52a584.807 584.807 0 0 0-58.69-75.52Z"
          className="cls-6th3"
        />
        <path
          d="M1016.35 1415.45c3.72-.92 5.27-36.91-4.41-39.62-.41-.12-2.24-.56-3.7.54-7.08 5.37 4.3 40.02 8.12 39.07Z"
          className="cls-6th15"
        />
        <path
          d="M1015.74 1416.3c-4.76-4.49 37.31-60.81 55.99-56.91.8.17 4.25 1 5.19 3.91 4.58 14.09-56.3 57.61-61.18 53Z"
          className="cls-6th3"
        />
        <path
          d="M998.4 1444.75c-2.4-4.42 38.63-36.47 50.87-29.29.52.31 2.76 1.72 2.82 4.08.28 11.49-51.23 29.74-53.69 25.21Z"
          className="cls-6th15"
        />
        <path
          d="M1005.81 1431.02c2.23-1.66-1.69-23.4-8.18-22.09-.28.06-1.5.34-2.27 1.44-3.75 5.31 8.16 22.36 10.45 20.66Z"
          className="cls-6th3"
        />
        <path
          d="M1031.14 1396.05a450.417 450.417 0 0 0-39.61 62.11c9.41-22.79 22.94-43.95 39.61-62.11Z"
          className="cls-6th3"
        />
        <path
          d="M1614.09 1520.38c4.07-1 5.76-40.37-4.83-43.33-.45-.13-2.45-.61-4.05.6-7.75 5.87 4.7 43.76 8.88 42.73Z"
          className="cls-6th15"
        />
        <path
          d="M1613.42 1521.32c-5.21-4.91 40.8-66.5 61.24-62.24.87.18 4.65 1.1 5.68 4.27 5 15.41-61.57 63.01-66.91 57.97Z"
          className="cls-6th3"
        />
        <path
          d="M1594.46 1552.43c-2.62-4.83 42.25-39.88 55.64-32.04.57.33 3.02 1.88 3.08 4.47.31 12.56-56.03 32.53-58.72 27.57Z"
          className="cls-6th15"
        />
        <path
          d="M1602.56 1537.42c2.44-1.82-1.84-25.6-8.95-24.16-.3.06-1.64.38-2.48 1.57-4.1 5.8 8.93 24.46 11.43 22.59Z"
          className="cls-6th3"
        />
        <path
          d="M1630.26 1499.17c-16.3 21.47-30.75 44.1-43.32 67.92 10.29-24.92 25.09-48.06 43.32-67.92Z"
          className="cls-6th3"
        />
        <path
          d="M1103.01 1593.4c4.9-1.76 1.94-50.63-11.53-52.93-.57-.1-3.11-.44-4.93 1.26-8.82 8.25 11.43 53.49 16.45 51.68Z"
          className="cls-6th15"
        />
        <path
          d="M1102.3 1594.64c-7.07-5.41 41.9-87.43 67.7-84.78 1.1.11 5.88.76 7.56 4.55 8.16 18.41-68.02 85.77-75.27 80.23Z"
          className="cls-6th3"
        />
        <path
          d="M1082.86 1635.52c-3.86-5.64 47.1-54.72 64.66-46.73.75.34 3.97 1.94 4.38 5.13 1.99 15.49-65.08 47.39-69.04 41.61Z"
          className="cls-6th15"
        />
        <path
          d="M1090.95 1615.93c2.78-2.56-5.56-31.4-14.16-28.72-.37.11-1.97.67-2.87 2.26-4.33 7.7 14.17 29.08 17.02 26.46Z"
          className="cls-6th3"
        />
        <path
          d="M1120.28 1565.11c-17.37 28.59-32.36 58.47-44.83 89.51 9.52-32.13 24.85-62.62 44.83-89.51Z"
          className="cls-6th3"
        />
        <path
          d="M949.2 1415.45c-3.72-.92-5.27-36.91 4.41-39.62.41-.12 2.24-.56 3.7.54 7.08 5.37-4.3 40.02-8.12 39.07Z"
          className="cls-6th15"
        />
        <path
          d="M949.82 1416.3c4.76-4.49-37.31-60.81-55.99-56.91-.8.17-4.25 1-5.19 3.91-4.58 14.09 56.3 57.61 61.18 53Z"
          className="cls-6th3"
        />
        <path
          d="M967.15 1444.75c2.4-4.42-38.63-36.47-50.87-29.29-.52.31-2.76 1.72-2.82 4.08-.28 11.49 51.23 29.74 53.69 25.21Z"
          className="cls-6th15"
        />
        <path
          d="M959.75 1431.02c-2.23-1.66 1.69-23.4 8.18-22.09.28.06 1.5.34 2.27 1.44 3.75 5.31-8.16 22.36-10.45 20.66Z"
          className="cls-6th3"
        />
        <path
          d="M934.42 1396.05c16.67 18.16 30.2 39.32 39.61 62.11a450.417 450.417 0 0 0-39.61-62.11Z"
          className="cls-6th3"
        />
        <path
          d="M834.87 1496.2c-4.08-2.81 3.38-57.08 15.29-57.36.51-.01 2.74.03 4.15 2.25 6.82 10.75-15.26 58-19.44 55.11Z"
          className="cls-6th21"
        />
        <path
          d="M835.37 1497.71c6.67-4.85-27.59-105.13-50.23-106.57-.96-.06-5.18-.15-7.01 3.81-8.92 19.24 50.41 107.73 57.24 102.76Z"
          className="cls-6th11"
        />
        <path
          d="M848.13 1546.85c3.91-5.66-35.37-69.36-51.39-63.41-.68.25-3.64 1.49-4.31 5-3.28 17.02 51.69 64.22 55.7 58.41Z"
          className="cls-6th21"
        />
        <path
          d="M843.08 1523.51c-2.16-3.34 7.96-34.24 15.15-29.77.31.19 1.64 1.09 2.26 3.02 2.98 9.37-15.2 30.18-17.41 26.75Z"
          className="cls-6th11"
        />
        <path
          d="M823.41 1462.63c14.91 34.34 24.97 70.86 29.93 107.97-7.68-36.62-17.57-72.63-29.93-107.97Z"
          className="cls-6th11"
        />
        <path
          d="M767.66 1665.77c-7.54-4.64-35.31-22.97-40.49-54.97-6.37-39.33 23.89-83.87 75.97-103.16 3.8 8.17 33.65 75.13-4.89 129.12-8.91 12.48-19.8 21.91-30.59 29.01Z"
          className="cls-6th12"
        />
        <path
          d="M758.97 1677.05c-.58-9.37-3.85-44.75-31.12-71.36-33.52-32.69-90.1-39.28-133.99-10.46 5.73 8.8 53.33 79.91 122.85 86.37 16.07 1.49 30.28-.75 42.27-4.55Z"
          className="cls-6th12"
        />
        <path
          d="M745.89 1648.5c-4.94 4.86-19.17 17.56-39.63 19.15-24.41 1.9-47.89-12.79-60.72-37.53 23.1-20.85 52.89-26.21 74.76-13.83 16.3 9.23 23.18 25.48 25.59 32.21Z"
          className="cls-6th22"
        />
        <path
          d="M745.89 1648.5c6.84 1.12 25.79 3.31 43.42-7.17 21.05-12.51 31.78-38.04 28.02-65.65-30.89-3.74-58.33 9.04-69.08 31.75-8.01 16.93-4.28 34.18-2.37 41.07ZM721.59 1571.8c-4.94 4.86-19.17 17.56-39.63 19.15-24.41 1.9-47.89-12.79-60.72-37.53 23.1-20.85 52.89-26.21 74.76-13.83 16.3 9.23 23.18 25.48 25.59 32.21Z"
          className="cls-6th22"
        />
        <path
          d="M721.59 1571.8c6.84 1.12 25.79 3.31 43.42-7.17 21.05-12.51 31.78-38.04 28.02-65.65-30.89-3.74-58.33 9.04-69.08 31.75-8.01 16.93-4.28 34.18-2.37 41.07ZM697.28 1495.11c-4.94 4.86-19.17 17.56-39.63 19.15-24.41 1.9-47.89-12.79-60.72-37.53 23.1-20.85 52.89-26.21 74.76-13.83 16.3 9.23 23.18 25.48 25.59 32.21Z"
          className="cls-6th22"
        />
        <path
          d="M697.28 1495.11c6.84 1.12 25.79 3.31 43.42-7.17 21.05-12.51 31.78-38.04 28.02-65.65-30.89-3.74-58.33 9.04-69.08 31.75-8.01 16.93-4.28 34.18-2.37 41.07ZM672.98 1418.42c-4.94 4.86-19.17 17.56-39.63 19.15-24.41 1.9-47.89-12.79-60.72-37.53 23.1-20.85 52.89-26.21 74.76-13.83 16.3 9.23 23.18 25.48 25.59 32.21Z"
          className="cls-6th22"
        />
        <path
          d="M672.98 1418.42c6.84 1.12 25.79 3.31 43.42-7.17 21.05-12.51 31.78-38.04 28.02-65.65-30.89-3.74-58.33 9.04-69.08 31.75-8.01 16.93-4.28 34.18-2.37 41.07Z"
          className="cls-6th22"
        />
        <path
          d="M652.25 1352.07c37.39 111.45 73.66 226.16 107.08 338.86-37.41-111.44-73.64-226.16-107.08-338.86Z"
          className="cls-6th22"
        />
        <path
          d="M658.95 1373.87c4.47-5.29 16.08-20.43 16.14-40.94.07-24.48-16.32-46.8-41.95-57.75-19.07 24.59-22.2 54.69-8.22 75.58 10.42 15.57 27.13 21.22 34.03 23.12ZM1358.37 1638.63c3.68 4.71 14.41 17.18 31.72 20.85 20.66 4.38 42.4-5.52 56.17-25.23-17.39-20.44-42.27-28.39-62.37-20.28-14.98 6.05-22.71 19.16-25.53 24.65Z"
          className="cls-6th22"
        />
        <path
          d="M1358.37 1638.63c-5.97.19-22.43-.09-36.32-11.04-16.58-13.08-22.88-36.12-16.54-59.31 26.84.29 48.86 14.32 55.48 34.96 4.94 15.39-.2 29.71-2.62 35.39ZM1387.83 1575.79c3.68 4.71 14.41 17.18 31.72 20.85 20.66 4.38 42.4-5.52 56.17-25.23-17.39-20.44-42.27-28.39-62.37-20.28-14.98 6.05-22.71 19.16-25.53 24.65Z"
          className="cls-6th22"
        />
        <path
          d="M1387.83 1575.79c-5.97.19-22.43-.09-36.32-11.04-16.58-13.08-22.88-36.12-16.54-59.31 26.84.29 48.86 14.32 55.48 34.96 4.94 15.39-.2 29.71-2.62 35.39ZM1417.28 1512.95c3.68 4.71 14.41 17.18 31.72 20.85 20.66 4.38 42.4-5.52 56.17-25.23-17.39-20.44-42.27-28.39-62.37-20.28-14.98 6.05-22.71 19.16-25.53 24.65Z"
          className="cls-6th22"
        />
        <path
          d="M1417.28 1512.95c-5.97.19-22.43-.09-36.32-11.04-16.58-13.08-22.88-36.12-16.54-59.31 26.84.29 48.86 14.32 55.48 34.96 4.94 15.39-.2 29.71-2.62 35.39ZM1446.74 1450.12c3.68 4.71 14.41 17.18 31.72 20.85 20.66 4.38 42.4-5.52 56.17-25.23-17.39-20.44-42.27-28.39-62.37-20.28-14.98 6.05-22.71 19.16-25.53 24.65Z"
          className="cls-6th22"
        />
        <path
          d="M1446.74 1450.12c-5.97.19-22.43-.09-36.32-11.04-16.58-13.08-22.88-36.12-16.54-59.31 26.84.29 48.86 14.32 55.48 34.96 4.94 15.39-.2 29.71-2.62 35.39Z"
          className="cls-6th22"
        />
        <path
          d="M1471.96 1395.72c-41.34 92.59-85.3 186.6-129.88 277.67 41.33-92.6 85.31-186.59 129.88-277.67Z"
          className="cls-6th22"
        />
        <path
          d="M1463.77 1413.61c-3.23-5.03-11.44-19.29-9.17-36.84 2.71-20.95 19.25-38.18 42.4-44.65 13.53 23.18 12.8 49.28-1.51 65.56-10.67 12.13-25.6 15.08-31.71 15.92Z"
          className="cls-6th22"
        />
        <path
          d="M1537.74 1697.57H462.26c-89.63 0-162.54-72.92-162.54-162.54V313.41c0-89.63 72.92-162.54 162.54-162.54h1075.48c89.63 0 162.54 72.92 162.54 162.54v1221.62c0 89.63-72.92 162.54-162.54 162.54ZM462.26 179.41c-73.88 0-133.99 60.11-133.99 133.99v1221.62c0 73.88 60.11 133.99 133.99 133.99h1075.48c73.88 0 133.99-60.11 133.99-133.99V313.41c0-73.88-60.11-133.99-133.99-133.99H462.26Z"
          className="cls-6th16"
        />
        <path
          d="M1399.07 1802c-23.12 30.48-59.25 38.68-105.8 40.82-16.88.78-35.12.75-54.61.71-9.48-.02-18.8-.04-27.91-.2-3.52-.07-7-.15-10.45-.26-4.16-.14-8.28-.32-12.35-.56-41.72-2.44-77.68-10.95-102.54-41.23-37.24-45.36-21.85-106.6-21-109.8 2.94-11.09 18.67-64.12 67.19-81.04 17.19-6 32.81-5.48 42.61-4.3 3.42-2.73 14.77-11.07 31.49-11.29 18.24-.23 30.51 9.36 33.68 12 3.69-2.23 27.16-15.91 49.77-6.09 4.99 2.17 9.06 5.1 12.32 8.15 18.84-3.38 43.44-3.92 65.74 8.32 57.13 31.35 72.17 131.62 31.87 184.75Z"
          className="cls-6th21"
        />
        <path
          d="M1367.21 1617.24c-4.42-2.43-8.93-4.34-13.47-5.84 8.96 5.4 19.24 13.36 27.68 25.18 41.31 57.85 9.35 167.06-45.83 190-23.79 9.89-36.39-2.71-101.69 2.86-26.4 2.25-47.58 6.3-60.51 9.11-69.28-30.46-103.27-100.14-86.53-156.15 15.87-53.07 71.4-74.22 78.88-76.94-9.32-.35-21.29.49-34.13 4.97-48.52 16.92-64.25 69.95-67.19 81.04-.85 3.2-16.24 64.44 21 109.8 24.86 30.28 60.81 38.79 102.54 41.23 4.06.24 8.18.42 12.35.56 3.45.11 6.93.2 10.45.26 9.11.16 18.43.18 27.91.2 19.49.04 37.73.07 54.61-.71 46.55-2.15 82.68-10.34 105.8-40.82 40.31-53.13 25.26-153.4-31.87-184.75Z"
          className="cls-6th11"
        />
        <path
          d="M1349.43 1744.22c.17 55.99-51.46 95.75-52.39 96.34-1.23.78-2.49 1.53-3.76 2.26-16.88.78-35.12.75-54.61.71-9.48-.02-18.8-.04-27.91-.2-1.03.04-4.83.13-10.45-.26-4.16-.14-8.28-.32-12.35-.56-.66-.39-1.32-.78-1.97-1.17-31.14-19.05-53.75-59.49-53.65-97.11.14-50.46 41.21-99.64 100.74-112.25-63.27 24.24-87.22 83.77-70.32 118.23 13.3 27.13 55.47 45.99 90.23 31.03 36.94-15.9 46.01-61.59 38.19-93.09-8.87-35.77-39.46-53.06-45.56-56.35 61.31 11.98 103.65 61.89 103.8 112.44Z"
          className="cls-6th11"
        />
        <path
          d="M1174.22 1606.15c6.26.78 13.17 2.08 20.53 4.18 19.91 5.68 35.07 14.95 45.35 22.68 8.8-6.26 21.41-13.69 37.71-18.86 8.67-2.75 16.7-4.33 23.66-5.22-3.65-3.43-10.52-8.87-20.55-11.37-21.39-5.33-38.85 7.3-41.53 9.31-3.8-3.3-12.59-9.99-25.58-11.9-21.15-3.11-36.74 8.91-39.59 11.19Z"
          className="cls-6th17"
        />
        <path
          d="M1210.75 1843.33c-1.03.04-4.83.13-10.45-.26-3.97-.28-8.86-.79-14.31-1.73-21.4-3.68-51.64-13.92-70.49-41.96-30.87-45.95-11.92-111.02 28.17-143.7 32.94-26.85 72.56-25.66 89.41-23.7 3.27.38 5.68.79 7.02 1.03-12.78 2.18-36.14 8.08-56.57 26.5-41.17 37.11-53.43 109.69-20.05 152.53 14.52 18.65 34.23 27.22 47.27 31.31ZM1240.1 1633c42.86-10.41 87.36 2.68 113.86 34.37 36.67 43.84 29.86 112.48-8.83 148.71-28.32 26.52-64.87 27.38-75.68 27.24 13.05-4.09 32.75-12.66 47.28-31.3 33.37-42.84 21.12-115.42-20.05-152.53-20.43-18.42-43.8-24.31-56.57-26.5Z"
          className="cls-6th13"
        />
        <path
          d="M1358.71 1743.32c-6.54-3.8-2.59-15.93-8.62-35.14-4.92-15.67-12.6-23.69-9.34-29.41 1.22-2.14 3.56-3.23 5.65-3.25 8.64-.09 17.65 18 21.41 30.02 3.58 11.45 7.1 32.41-1.23 37.47-.24.15-4.17 2.45-7.86.31Z"
          className="cls-6th5"
        />
        <path
          d="M1220.8 1620.77c-1.3-15.38-.26-37.67 12.46-58.35 12.49-20.3 34.42-34.49 37.71-31.83.93.76 1.47 3.76 1.59 4.46.43 2.39.03 3.53.16 5.73.2 3.44 1.44 5.19 1.75 6.52 1.43 6.05-13.74 13.55-19.41 19.26-6.43 6.46-10.79 20.79 1.52 56.37-2.7 1.4-5.55 2.99-8.48 4.78-2.89 1.77-5.55 3.54-8 5.28-3.23-2.43-6.82-4.92-10.8-7.37-2.93-1.81-5.77-3.42-8.5-4.85Z"
          className="cls-6th3"
        />
        <ellipse
          cx={1351.36}
          cy={1686.87}
          className="cls-6th18"
          rx={3.54}
          ry={7.07}
          transform="rotate(-27.31 1351.594 1687.042)"
        />
        <ellipse
          cx={1324.12}
          cy={1655.2}
          className="cls-6th5"
          rx={3.58}
          ry={12.41}
          transform="rotate(-47.34 1324.296 1655.292)"
        />
        <path
          d="M1132.53 1756.88c5.94 5.23.49 12.26 4.61 25.62 5.45 17.65 21.34 26 17.66 33.1-.21.4-.6 1.14-1.44 1.7-5.51 3.7-19.94-7.2-27.98-16.41-11.29-12.95-21.06-35.33-13.24-43.69 4.56-4.87 15.09-4.96 20.37-.32Z"
          className="cls-6th5"
        />
        <ellipse
          cx={1118.25}
          cy={1770.25}
          className="cls-6th18"
          rx={3.22}
          ry={4.89}
        />
        <ellipse
          cx={1184.58}
          cy={1701.37}
          className="cls-6th9"
          rx={37.18}
          ry={15.11}
          transform="rotate(-68.48 1184.599 1701.381)"
        />
        <ellipse
          cx={1213.97}
          cy={1653.06}
          className="cls-6th9"
          rx={7.43}
          ry={6.44}
          transform="rotate(-56.06 1214.134 1653.13)"
        />
        <ellipse
          cx={1158.64}
          cy={1626.15}
          className="cls-6th9"
          rx={10.98}
          ry={5.23}
          transform="rotate(-27.31 1158.827 1626.326)"
        />
        <path
          d="M1323.8 1632.36c-10.52-4.48-18.2-2.37-20.24-7.34-.16-.38-.88-2.15-.11-3.65 2.28-4.41 15.47-2.66 24.91 1.59 2.74 1.24 13.78 6.21 13.47 12.63-.01.25-.18 2.96-2.05 4.06-3.23 1.9-7.19-3.54-15.99-7.29Z"
          className="cls-6th9"
        />
        <path
          d="M1274.47 1547.31c.16-1.1-.82-1.52-1.42-4.19-.15-.68-.27-1.45-.33-2.34-.13-2.2.27-3.34-.16-5.73-.12-.69-.66-3.7-1.59-4.46-3.29-2.66-25.23 11.52-37.71 31.83-12.72 20.68-13.76 42.97-12.46 58.35 2.73 1.44 5.57 3.05 8.5 4.85a146.1 146.1 0 0 1 10.8 7.37c2.45-1.74 5.11-3.52 8-5.28 2.94-1.8 5.78-3.38 8.48-4.78a210.36 210.36 0 0 1-2.88-8.95c-1.07-.64-3.06-1.62-5.33-1.28-6.08.92-7.43 10.36-10.66 10.34-3.58-.02-8.13-11.6-8.12-24.03.02-14.83 6.56-25.86 11.93-34.69 11.06-18.15 24.8-28.64 25.94-27.69.81.68-4.94 7.17-2.55 11.3 1.12 1.93 3.44 2.35 3.66 2.39 2.65.44 5.62-1.24 5.89-3.02Z"
          className="cls-6th15"
        />
        <path
          d="M1233.1 1597.49c-.51 8.77 2.64 16.37 3.46 16.23.7-.12-.54-5.88 0-16.83.45-9.1 1.73-13.73 1.12-13.88-.76-.19-4.12 6.5-4.58 14.48Z"
          className="cls-6th24"
        />
        <path
          d="M591.05 1802.67c12.93 23.94 33.14 30.38 59.18 32.06 9.44.61 19.65.59 30.55.56 5.3-.01 10.52-.03 15.61-.16 1.97-.05 3.91-.12 5.84-.21 2.33-.11 4.63-.25 6.91-.44 23.34-1.92 43.45-8.6 57.36-32.38 20.83-35.63 12.22-83.73 11.75-86.24-1.65-8.71-10.45-50.36-37.59-63.65-9.62-4.71-18.35-4.31-23.84-3.37-1.91-2.14-8.26-8.7-17.61-8.87-10.2-.18-17.07 7.35-18.84 9.43-2.06-1.75-15.2-12.5-27.84-4.78-2.79 1.7-5.07 4.01-6.89 6.4-10.54-2.66-24.3-3.08-36.77 6.54-31.96 24.62-40.37 103.38-17.83 145.11Z"
          className="cls-6th21"
        />
        <path
          d="M608.88 1657.55c2.47-1.91 5-3.41 7.54-4.59-5.01 4.24-10.76 10.49-15.48 19.78-23.11 45.44-5.23 131.22 25.64 149.24 13.31 7.77 20.36-2.13 56.88 2.25a195.09 195.09 0 0 1 33.85 7.16c38.75-23.93 57.77-78.65 48.4-122.65-8.88-41.68-39.94-58.29-44.13-60.43 5.21-.28 11.91.39 19.09 3.91 27.14 13.29 35.94 54.94 37.59 63.65.48 2.51 9.08 50.62-11.75 86.24-13.91 23.78-34.02 30.47-57.36 32.38-2.27.19-4.58.33-6.91.44-1.93.09-3.88.15-5.84.21-5.1.13-10.31.14-15.61.16-10.9.03-21.11.05-30.55-.56-26.04-1.69-46.25-8.13-59.18-32.06-22.55-41.73-14.13-120.49 17.83-145.11Z"
          className="cls-6th11"
        />
        <path
          d="M618.83 1757.29c-.1 43.98 28.79 75.21 29.31 75.67.69.61 1.39 1.2 2.1 1.77 9.44.61 19.65.59 30.55.56 5.3-.01 10.52-.03 15.61-.16.58.03 2.7.1 5.84-.21 2.33-.11 4.63-.25 6.91-.44.37-.3.74-.61 1.1-.92 17.42-14.96 30.07-46.73 30.01-76.28-.08-39.63-23.05-78.26-56.35-88.17 35.39 19.04 48.79 65.79 39.34 92.86-7.44 21.31-31.03 36.12-50.47 24.37-20.66-12.48-25.74-48.37-21.36-73.12 4.96-28.1 22.08-41.68 25.49-44.26-34.3 9.41-57.98 48.61-58.07 88.31Z"
          className="cls-6th11"
        />
        <path
          d="M716.84 1648.84c-3.5.61-7.37 1.63-11.48 3.28-11.14 4.46-19.62 11.74-25.37 17.81-4.92-4.92-11.98-10.75-21.1-14.81-4.85-2.16-9.34-3.4-13.23-4.1 2.04-2.69 5.89-6.97 11.5-8.93 11.96-4.19 21.73 5.73 23.23 7.31 2.13-2.59 7.04-7.85 14.31-9.35 11.83-2.44 20.55 7 22.14 8.79Z"
          className="cls-6th17"
        />
        <path
          d="M696.4 1835.13c.58.03 2.7.1 5.84-.21 2.22-.22 4.96-.62 8.01-1.36 11.97-2.89 28.89-10.93 39.43-32.96 17.27-36.09 6.67-87.2-15.76-112.87-18.42-21.09-40.59-20.16-50.02-18.62-1.83.3-3.18.62-3.93.81 7.15 1.71 20.22 6.35 31.65 20.81 23.03 29.15 29.89 86.16 11.22 119.8-8.12 14.65-19.15 21.38-26.44 24.59Z"
          className="cls-6th13"
        />
        <path
          d="M679.98 1669.93c-23.97-8.18-48.87 2.11-63.69 27-20.51 34.44-16.71 88.35 4.94 116.8 15.84 20.83 36.29 21.51 42.34 21.4-7.3-3.21-18.32-9.94-26.45-24.59-18.67-33.65-11.82-90.66 11.22-119.8 11.43-14.47 24.5-19.1 31.65-20.81Z"
          className="cls-6th13"
        />
        <path
          d="M613.63 1756.58c3.66-2.98 1.45-12.51 4.82-27.6 2.75-12.3 7.05-18.61 5.23-23.1-.68-1.68-1.99-2.53-3.16-2.55-4.84-.07-9.87 14.14-11.97 23.58-2 8.99-3.97 25.45.69 29.43.14.12 2.34 1.92 4.4.24Z"
          className="cls-6th5"
        />
        <path
          d="M690.78 1660.33c.73-12.08.15-29.59-6.97-45.83-6.99-15.95-19.26-27.09-21.1-25-.52.59-.82 2.96-.89 3.5-.24 1.88-.02 2.77-.09 4.5-.11 2.7-.8 4.08-.98 5.12-.8 4.75 7.69 10.64 10.86 15.12 3.59 5.07 6.04 16.33-.85 44.28 1.51 1.1 3.1 2.35 4.75 3.76 1.62 1.39 3.11 2.78 4.47 4.15a86.64 86.64 0 0 1 6.04-5.79c1.64-1.42 3.23-2.68 4.75-3.81Z"
          className="cls-6th3"
        />
        <ellipse
          cx={617.74}
          cy={1712.24}
          className="cls-6th18"
          rx={5.3}
          ry={2.07}
          transform="rotate(-72.78 617.752 1712.243)"
        />
        <ellipse
          cx={632.98}
          cy={1687.36}
          className="cls-6th5"
          rx={8.39}
          ry={2.33}
          transform="rotate(-53.96 632.94 1687.334)"
        />
        <path
          d="M740.16 1767.23c-3.32 4.1-.27 9.63-2.58 20.12-3.05 13.87-11.94 20.42-9.88 26 .12.32.34.9.8 1.34 3.08 2.91 11.16-5.65 15.65-12.89 6.31-10.17 11.78-27.75 7.4-34.32-2.55-3.83-8.44-3.9-11.39-.25Z"
          className="cls-6th5"
        />
        <ellipse
          cx={748.15}
          cy={1777.73}
          className="cls-6th18"
          rx={1.8}
          ry={3.84}
        />
        <ellipse
          cx={711.04}
          cy={1723.63}
          className="cls-6th9"
          rx={8.72}
          ry={28.3}
          transform="rotate(-14.26 710.825 1723.278)"
        />
        <ellipse
          cx={694.6}
          cy={1685.68}
          className="cls-6th9"
          rx={3.73}
          ry={5.65}
          transform="rotate(-9.01 694.437 1685.422)"
        />
        <ellipse
          cx={725.55}
          cy={1664.55}
          className="cls-6th9"
          rx={3.68}
          ry={6.86}
          transform="rotate(-47.24 725.681 1664.653)"
        />
        <path
          d="M633.16 1669.42c5.89-3.52 10.18-1.86 11.32-5.77.09-.3.49-1.69.06-2.87-1.27-3.46-8.65-2.09-13.94 1.25-1.53.97-7.71 4.88-7.54 9.92 0 .2.1 2.32 1.15 3.19 1.81 1.49 4.02-2.78 8.94-5.72Z"
          className="cls-6th9"
        />
        <path
          d="M660.75 1602.62c-.09-.86.46-1.19.8-3.29.09-.54.15-1.14.18-1.83.07-1.73-.15-2.62.09-4.5.07-.54.37-2.91.89-3.5 1.84-2.09 14.11 9.05 21.1 25 7.11 16.24 7.7 33.75 6.97 45.83a75.478 75.478 0 0 0-4.75 3.81 84.469 84.469 0 0 0-6.04 5.79 83.415 83.415 0 0 0-4.47-4.15 72.505 72.505 0 0 0-4.75-3.76c.61-2.47 1.14-4.81 1.61-7.03.6-.5 1.71-1.27 2.98-1 3.4.72 4.16 8.14 5.96 8.12 2-.01 4.55-9.11 4.54-18.87-.01-11.65-3.67-20.31-6.68-27.25-6.19-14.26-13.88-22.5-14.51-21.75-.46.54 2.76 5.63 1.42 8.87-.62 1.51-1.92 1.85-2.05 1.87-1.48.35-3.14-.97-3.29-2.37Z"
          className="cls-6th15"
        />
        <path
          d="M683.9 1642.04c.28 6.89-1.48 12.86-1.94 12.75-.39-.09.3-4.62 0-13.22-.25-7.15-.97-10.78-.62-10.9.42-.15 2.3 5.1 2.56 11.37Z"
          className="cls-6th24"
        />
        <path
          d="M763.47 1798.53c22.55 37.12 57.78 47.1 103.19 49.72 16.46.95 34.25.92 53.26.87 9.25-.02 18.34-.05 27.22-.24 3.43-.08 6.82-.18 10.19-.32 4.06-.17 8.08-.39 12.04-.68 40.7-2.97 75.76-13.34 100.01-50.21 36.32-55.24 21.31-129.83 20.48-133.72-2.87-13.5-18.21-78.08-65.53-98.69-16.76-7.3-32-6.68-41.56-5.23-3.34-3.32-14.4-13.49-30.71-13.75-17.79-.28-29.76 11.4-32.85 14.62-3.6-2.71-26.49-19.38-48.54-7.41-4.87 2.64-8.84 6.21-12.01 9.92-18.38-4.12-42.36-4.77-64.12 10.13-55.72 38.18-70.39 160.29-31.08 225Z"
          className="cls-6th10"
        />
        <path
          d="M811.9 1726.65c-.17 68.19 50.19 116.61 51.1 117.32 1.2.94 2.43 1.86 3.67 2.75 16.46.95 34.25.92 53.26.87 9.25-.02 18.34-.05 27.22-.24 1 .05 4.71.15 10.19-.32 4.06-.17 8.08-.39 12.04-.68.65-.47 1.29-.95 1.92-1.43 30.37-23.2 52.42-72.45 52.32-118.27-.14-61.46-40.19-121.35-98.25-136.71 42.77 6.7 74.49 51.39 74.63 101.83.16 56.42-39.25 104.11-75.78 101.6-44.16-3.04-77.75-79-63.56-136.92 10.82-44.15 45.85-63.28 52.47-66.73-59.8 14.59-101.09 75.37-101.24 136.93Z"
          className="cls-6th6"
        />
        <path
          d="M982.78 1560.02c-6.1.95-12.85 2.53-20.02 5.09-19.42 6.92-34.2 18.2-44.23 27.62-8.59-7.62-20.88-16.67-36.78-22.97-8.46-3.35-16.28-5.27-23.07-6.35 3.56-4.17 10.26-10.81 20.05-13.85 20.86-6.49 37.89 8.89 40.51 11.34 3.71-4.02 12.28-12.17 24.95-14.49 20.63-3.79 35.83 10.85 38.61 13.62Z"
          style={{
            fill: "#c16e00",
          }}
        />
        <path
          d="M947.15 1848.87c1 .05 4.71.15 10.19-.32 3.88-.34 8.64-.96 13.96-2.11 20.88-4.49 50.37-16.95 68.75-51.11 30.11-55.96 11.63-135.2-27.47-175-32.12-32.7-70.77-31.25-87.21-28.87-3.19.46-5.54.96-6.85 1.25 12.46 2.66 35.25 9.84 55.18 32.27 40.16 45.2 52.11 133.59 19.56 185.76-14.17 22.71-33.38 33.14-46.11 38.13Z"
          className="cls-6th8"
        />
        <path
          d="M918.52 1592.72c-41.8-12.68-85.2 3.27-111.05 41.86-35.76 53.39-29.13 136.98 8.61 181.11 27.62 32.29 63.27 33.35 73.82 33.18-12.72-4.98-31.95-15.42-46.11-38.12-32.55-52.17-20.6-140.56 19.56-185.76 19.93-22.43 42.71-29.61 55.18-32.27Z"
          className="cls-6th8"
        />
        <path
          d="M802.85 1727.07c6.38-4.62 2.52-19.4 8.41-42.79 4.8-19.08 12.29-28.85 9.11-35.81-1.19-2.61-3.47-3.93-5.51-3.96-8.43-.12-17.21 21.93-20.88 36.56-3.49 13.94-6.93 39.47 1.2 45.63.24.18 4.07 2.98 7.67.38Z"
          className="cls-6th10"
        />
        <path
          d="M937.35 1577.83c-6.77-29.91-10.23-54.13-12.15-71.06-1.62-14.31-2.24-24.34-6.49-25.86-6.18-2.22-18.89 14.03-18.62 30.04.21 13.13 9 17 11.49 31.2 2.56 14.67-3.63 28.81-9.13 38.31 2.64 1.71 5.41 3.64 8.28 5.82 2.82 2.15 5.42 4.31 7.8 6.43 3.15-2.96 6.66-5.99 10.53-8.98 2.85-2.2 5.63-4.16 8.29-5.91Z"
          style={{
            fill: "#4f6b19",
          }}
        />
        <ellipse
          cx={810.01}
          cy={1658.33}
          className="cls-6th2"
          rx={8.31}
          ry={3.57}
          transform="rotate(-69.92 810.054 1658.35)"
        />
        <ellipse
          cx={836.57}
          cy={1619.76}
          className="cls-6th10"
          rx={13.6}
          ry={3.88}
          transform="rotate(-50.14 836.595 1619.775)"
        />
        <path
          d="M1023.44 1743.59c-5.79 6.36-.47 14.93-4.5 31.2-5.32 21.5-20.81 31.66-17.23 40.31.2.49.59 1.39 1.4 2.07 5.37 4.51 19.45-8.77 27.29-19.99 11.01-15.77 20.54-43.03 12.91-53.21-4.45-5.93-14.71-6.05-19.87-.39Z"
          className="cls-6th10"
        />
        <ellipse
          cx={1037.37}
          cy={1759.87}
          className="cls-6th2"
          rx={3.14}
          ry={5.96}
        />
        <ellipse
          cx={957.46}
          cy={1647.88}
          className="cls-6th2"
          rx={16.08}
          ry={36.41}
          transform="rotate(-25.4 957.517 1647.937)"
        />
        <ellipse
          cx={997.98}
          cy={1584.38}
          className="cls-6th2"
          rx={5.98}
          ry={11.4}
          transform="rotate(-53.14 998.03 1584.408)"
        />
        <path
          d="M836.89 1591.94c10.26-5.45 17.75-2.89 19.74-8.94.15-.46.86-2.62.1-4.45-2.22-5.37-15.09-3.24-24.3 1.94-2.67 1.51-13.44 7.57-13.14 15.39.01.31.18 3.6 2 4.94 3.15 2.31 7.01-4.31 15.59-8.87Z"
          className="cls-6th2"
        />
        <path
          d="M908.7 1510.73c.21 8.41 7.66 13.98 9.29 13.46 1.4-.44-1.92-5.21-2.38-15.67-.38-8.69 1.56-13.61.3-13.46-1.56.19-7.41 8.02-7.22 15.67Z"
          style={{
            fill: "#6b8929",
          }}
        />
        <path
          d="M918.98 1573.3c-4.4-6.72 4.68-17.23 1.51-31.98-3.03-14.09-13.42-14.28-14.67-26.89-1.25-12.65 7.76-27.12 13.15-26.16 2.23.4 3.79 3.42 4.81 6.21-.99-7.57-2.2-12.53-5.08-13.57-6.18-2.22-18.89 14.03-18.62 30.04.21 13.13 9 17 11.49 31.2 2.56 14.67-3.63 28.81-9.13 38.31 2.64 1.71 5.41 3.64 8.28 5.82 2.82 2.15 5.42 4.31 7.8 6.43 3.15-2.96 6.66-5.99 10.53-8.98 2.85-2.2 5.63-4.16 8.29-5.91-.21-.94-.42-1.87-.63-2.8-11.75 3.51-15.97.96-17.73-1.73Z"
          className="cls-6th16"
        />
        <path
          d="M1028.2 1442.6c4.16-2.85 6.35-5.74 5.89-8.34-.46-2.6-3.5-4.57-8.39-5.83 2.93-4.1 4-7.57 2.68-9.85-1.32-2.29-4.86-3.09-9.88-2.6 1.35-4.86 1.17-8.48-.85-10.18-2.02-1.7-5.62-1.24-10.17.93-.39-5.03-1.8-8.37-4.28-9.27-2.48-.9-5.71.75-9.24 4.35-2.09-4.59-4.55-7.25-7.19-7.25s-5.11 2.66-7.19 7.25c-3.53-3.6-6.76-5.25-9.24-4.35-2.48.9-3.89 4.24-4.28 9.27-4.55-2.17-8.15-2.63-10.17-.93-2.02 1.7-2.2 5.32-.85 10.18-5.02-.49-8.56.32-9.88 2.6-1.32 2.29-.25 5.75 2.68 9.85-4.88 1.26-7.93 3.23-8.39 5.83-.46 2.6 1.73 5.49 5.89 8.34-4.16 2.85-6.35 5.74-5.89 8.34.46 2.6 3.5 4.57 8.39 5.83-2.93 4.1-4 7.57-2.68 9.85s4.86 3.09 9.88 2.6c-1.35 4.86-1.17 8.48.85 10.18 2.02 1.7 5.62 1.24 10.17-.93.39 5.03 1.8 8.37 4.28 9.27 2.48.9 5.71-.75 9.24-4.35 2.09 4.59 4.55 7.25 7.19 7.25s5.11-2.66 7.19-7.25c3.53 3.6 6.76 5.25 9.24 4.35 2.48-.9 3.89-4.24 4.28-9.27 4.55 2.17 8.15 2.63 10.17.93 2.02-1.7 2.2-5.32.85-10.18 5.02.49 8.56-.32 9.88-2.6s.25-5.75-2.68-9.85c4.88-1.26 7.93-3.23 8.39-5.83.46-2.6-1.73-5.49-5.89-8.34Z"
          className="cls-6th22"
        />
        <path
          d="M1013.51 1442.6c2.68-1.84 4.1-3.71 3.8-5.38-.3-1.68-2.26-2.95-5.41-3.76 1.89-2.65 2.58-4.88 1.73-6.36-.85-1.48-3.13-1.99-6.37-1.68.87-3.14.76-5.47-.55-6.57-1.31-1.1-3.63-.8-6.56.6-.25-3.25-1.16-5.4-2.76-5.98-1.6-.58-3.68.48-5.96 2.81-1.35-2.96-2.94-4.68-4.64-4.68s-3.3 1.71-4.64 4.68c-2.28-2.32-4.36-3.39-5.96-2.81-1.6.58-2.51 2.74-2.76 5.98-2.94-1.4-5.26-1.7-6.56-.6-1.31 1.1-1.42 3.43-.55 6.57-3.24-.31-5.52.2-6.37 1.68-.85 1.48-.16 3.71 1.73 6.36-3.15.81-5.12 2.08-5.41 3.76-.3 1.68 1.12 3.54 3.8 5.38-2.68 1.84-4.1 3.71-3.8 5.38.3 1.68 2.26 2.95 5.41 3.76-1.89 2.65-2.58 4.88-1.73 6.36s3.13 1.99 6.37 1.68c-.87 3.14-.76 5.47.55 6.57 1.31 1.1 3.63.8 6.56-.6.25 3.25 1.16 5.4 2.76 5.98 1.6.58 3.68-.48 5.96-2.81 1.35 2.96 2.94 4.68 4.64 4.68s3.3-1.71 4.64-4.68c2.28 2.32 4.36 3.39 5.96 2.81 1.6-.58 2.51-2.74 2.76-5.98 2.94 1.4 5.26 1.7 6.56.6 1.31-1.1 1.42-3.43.55-6.57 3.24.31 5.52-.2 6.37-1.68s.16-3.71-1.73-6.36c3.15-.81 5.12-2.08 5.41-3.76.3-1.68-1.12-3.54-3.8-5.38Z"
          style={{
            fill: "#af0c04",
          }}
        />
        <circle
          cx={986.77}
          cy={1442.6}
          r={13.97}
          style={{
            fill: "#7c0404",
          }}
        />
        <path
          d="M569.27 1570.6c6.35-4.36 9.7-8.77 8.99-12.75-.7-3.97-5.35-6.98-12.81-8.9 4.48-6.27 6.11-11.56 4.09-15.06-2.02-3.49-7.42-4.72-15.09-3.98 2.07-7.42 1.79-12.96-1.3-15.55s-8.59-1.9-15.54 1.42c-.6-7.69-2.75-12.79-6.54-14.17-3.79-1.38-8.72 1.14-14.12 6.64-3.19-7.01-6.96-11.07-10.99-11.07s-7.8 4.06-10.99 11.07c-5.4-5.5-10.32-8.02-14.12-6.64-3.79 1.38-5.95 6.48-6.54 14.17-6.95-3.32-12.45-4.01-15.54-1.42s-3.36 8.13-1.3 15.55c-7.67-.75-13.07.48-15.09 3.98-2.02 3.5-.39 8.79 4.09 15.06-7.46 1.92-12.11 4.93-12.81 8.9-.7 3.97 2.64 8.39 8.99 12.75-6.35 4.36-9.7 8.77-8.99 12.75.7 3.97 5.35 6.98 12.81 8.9-4.48 6.27-6.11 11.56-4.09 15.05 2.02 3.5 7.42 4.72 15.09 3.98-2.07 7.42-1.79 12.96 1.3 15.55s8.59 1.9 15.54-1.42c.6 7.69 2.75 12.79 6.54 14.17 3.79 1.38 8.72-1.14 14.12-6.64 3.19 7.01 6.96 11.07 10.99 11.07s7.8-4.06 10.99-11.07c5.4 5.5 10.32 8.03 14.12 6.64 3.79-1.38 5.94-6.48 6.54-14.17 6.95 3.32 12.45 4.01 15.54 1.42s3.36-8.13 1.3-15.55c7.67.75 13.07-.48 15.09-3.98 2.02-3.5.39-8.79-4.09-15.05 7.46-1.92 12.11-4.93 12.81-8.9.7-3.97-2.64-8.39-8.99-12.75Z"
          className="cls-6th21"
        />
        <path
          d="M546.82 1570.6c4.1-2.81 6.26-5.66 5.8-8.23-.45-2.56-3.45-4.5-8.27-5.74 2.89-4.05 3.94-7.46 2.64-9.72-1.3-2.26-4.79-3.05-9.74-2.57 1.33-4.79 1.16-8.36-.84-10.04-1.99-1.67-5.54-1.23-10.03.92-.39-4.96-1.77-8.25-4.22-9.14-2.45-.89-5.63.74-9.11 4.29-2.06-4.53-4.49-7.14-7.09-7.14s-5.03 2.62-7.09 7.14c-3.48-3.55-6.66-5.18-9.11-4.29-2.45.89-3.84 4.18-4.22 9.14-4.49-2.14-8.03-2.59-10.03-.92s-2.17 5.25-.84 10.04c-4.95-.48-8.44.31-9.74 2.57-1.3 2.26-.25 5.67 2.64 9.72-4.82 1.24-7.82 3.18-8.27 5.74-.45 2.56 1.7 5.41 5.8 8.23-4.1 2.81-6.26 5.66-5.8 8.23.45 2.56 3.45 4.5 8.27 5.74-2.89 4.05-3.94 7.46-2.64 9.72s4.79 3.05 9.74 2.57c-1.33 4.79-1.16 8.36.84 10.04 1.99 1.67 5.54 1.23 10.03-.92.39 4.96 1.77 8.25 4.22 9.14 2.45.89 5.63-.74 9.11-4.29 2.06 4.53 4.49 7.14 7.09 7.14s5.03-2.62 7.09-7.14c3.48 3.55 6.66 5.18 9.11 4.29 2.45-.89 3.84-4.18 4.22-9.14 4.49 2.14 8.03 2.59 10.03.92s2.17-5.25.84-10.04c4.95.48 8.44-.31 9.74-2.57s.25-5.67-2.64-9.72c4.82-1.24 7.82-3.18 8.27-5.74.45-2.56-1.7-5.41-5.8-8.23Z"
          className="cls-6th11"
        />
        <circle
          cx={505.97}
          cy={1570.6}
          r={21.34}
          style={{
            fill: "#a03805",
          }}
        />
        <path
          d="M1610.81 1580.39c4.89-3.35 7.46-6.75 6.92-9.81-.54-3.06-4.12-5.37-9.86-6.85 3.45-4.82 4.7-8.9 3.15-11.58-1.55-2.69-5.71-3.63-11.61-3.06 1.59-5.71 1.38-9.97-1-11.97s-6.61-1.46-11.95 1.09c-.46-5.91-2.12-9.84-5.03-10.9-2.92-1.06-6.71.88-10.86 5.11-2.45-5.4-5.35-8.52-8.46-8.52s-6 3.12-8.46 8.52c-4.15-4.23-7.94-6.17-10.86-5.11-2.92 1.06-4.57 4.99-5.03 10.9-5.35-2.56-9.58-3.09-11.95-1.09-2.38 2-2.59 6.25-1 11.97-5.9-.57-10.06.37-11.61 3.06-1.55 2.69-.3 6.76 3.15 11.58-5.74 1.48-9.32 3.79-9.86 6.85-.54 3.06 2.03 6.45 6.92 9.81-4.89 3.35-7.46 6.75-6.92 9.81.54 3.06 4.12 5.37 9.86 6.85-3.45 4.82-4.7 8.89-3.15 11.58 1.55 2.69 5.71 3.63 11.61 3.06-1.59 5.71-1.38 9.97 1 11.97s6.61 1.46 11.95-1.09c.46 5.91 2.12 9.84 5.03 10.9 2.92 1.06 6.71-.88 10.86-5.11 2.45 5.4 5.35 8.52 8.46 8.52s6-3.12 8.46-8.52c4.15 4.23 7.94 6.18 10.86 5.11 2.92-1.06 4.57-4.99 5.03-10.9 5.35 2.56 9.58 3.09 11.95 1.09 2.38-2 2.59-6.25 1-11.97 5.9.57 10.06-.37 11.61-3.06 1.55-2.69.3-6.76-3.15-11.58 5.74-1.48 9.32-3.79 9.86-6.85.54-3.06-2.03-6.45-6.92-9.81Z"
          className="cls-6th10"
        />
        <path
          d="M1593.54 1580.39c3.16-2.16 4.81-4.36 4.47-6.33-.35-1.97-2.66-3.47-6.36-4.42 2.22-3.11 3.03-5.74 2.03-7.48-1-1.74-3.68-2.34-7.49-1.97 1.03-3.69.89-6.43-.64-7.72s-4.26-.94-7.71.71c-.3-3.82-1.37-6.35-3.25-7.04-1.88-.69-4.33.57-7.01 3.3-1.58-3.48-3.45-5.5-5.46-5.5s-3.87 2.01-5.46 5.5c-2.68-2.73-5.13-3.98-7.01-3.3-1.88.69-2.95 3.22-3.25 7.04-3.45-1.65-6.18-1.99-7.71-.71-1.54 1.29-1.67 4.04-.64 7.72-3.81-.37-6.49.24-7.49 1.97-1 1.74-.19 4.36 2.03 7.48-3.71.95-6.01 2.45-6.36 4.42-.35 1.97 1.31 4.17 4.47 6.33-3.16 2.16-4.81 4.36-4.47 6.33.35 1.97 2.66 3.47 6.36 4.42-2.22 3.11-3.03 5.74-2.03 7.48s3.68 2.35 7.49 1.98c-1.03 3.69-.89 6.43.64 7.72s4.26.94 7.71-.71c.3 3.82 1.37 6.35 3.25 7.04 1.88.69 4.33-.57 7.01-3.3 1.58 3.48 3.45 5.5 5.46 5.5s3.87-2.01 5.46-5.5c2.68 2.73 5.13 3.98 7.01 3.3 1.88-.69 2.95-3.22 3.25-7.04 3.45 1.65 6.18 1.99 7.71.71 1.54-1.29 1.67-4.04.64-7.72 3.81.37 6.49-.24 7.49-1.98s.19-4.36-2.03-7.48c3.71-.96 6.01-2.45 6.36-4.42.35-1.97-1.31-4.16-4.47-6.33Z"
          className="cls-6th6"
        />
        <circle
          cx={1562.11}
          cy={1580.39}
          r={16.42}
          style={{
            fill: "#ba7006",
          }}
        />
        {children}
      </g>
    </svg>
  );
}
